const CATEGORY_LABELS = new Map<string, string>([
  ['idp', 'Identity Provider'],
  ['mdm', 'MDM'],
  ['hris', 'HRIS'],
  ['itsm', 'ITSM'],
  ['ai', 'AI'],
  ['collaboration', 'Collaboration'],
  ['knowledge-base', 'Knowledge Base'],
  ['saas-apps', 'SaaS Apps'],
]);

const CATEGORY_COLORS = new Map<string, string>([
  ['idp', 'border-blue-200 bg-blue-50/50 dark:border-blue-800 dark:bg-blue-950/50'],
  ['mdm', 'border-purple-200 bg-purple-50/50 dark:border-purple-800 dark:bg-purple-950/50'],
  ['hris', 'border-green-200 bg-green-50/50 dark:border-green-800 dark:bg-green-950/50'],
  ['itsm', 'border-orange-200 bg-orange-50/50 dark:border-orange-800 dark:bg-orange-950/50'],
  ['collaboration', 'border-pink-200 bg-pink-50/50 dark:border-pink-800 dark:bg-pink-950/50'],
  ['ai', 'border-cyan-200 bg-cyan-50/50 dark:border-cyan-800 dark:bg-cyan-950/50'],
  ['knowledge-base', 'border-amber-200 bg-amber-50/50 dark:border-amber-800 dark:bg-amber-950/50'],
  ['saas-apps', 'border-indigo-200 bg-indigo-50/50 dark:border-indigo-800 dark:bg-indigo-950/50'],
]);

export function formatCategory(category: string): string {
  return CATEGORY_LABELS.get(category.toLowerCase()) ?? category
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function getCategoryColor(category: string): string {
  return CATEGORY_COLORS.get(category.toLowerCase()) ?? 'border-border bg-muted/30';
}
